var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CustomFormat_1;
import { JSON, JsonSchema } from '@symon-ai/wisepipe-serialize';
export var ColumnFormat;
(function (ColumnFormat) {
    ColumnFormat["None"] = "none";
    // Number Formats
    ColumnFormat["Currency"] = "currency";
    ColumnFormat["Percentage"] = "percentage";
    // Date Formats
    ColumnFormat["FullDateAndTime"] = "fullDateAndTime";
    ColumnFormat["LongDate"] = "longDate";
    ColumnFormat["ShortDate"] = "shortDate";
    ColumnFormat["Time"] = "time";
    ColumnFormat["ShortMonth"] = "shortMonth";
})(ColumnFormat || (ColumnFormat = {}));
export const DefaultSettings = {
    format: ColumnFormat.None,
    decimalPlace: undefined,
    thousandSeparator: false
};
const schema = {
    $id: 'urn:wisepipe-common-pipe:CustomFormat',
    type: 'object',
    properties: {
        format: { type: 'string', enum: Object.values(ColumnFormat) },
        decimalPlace: { type: 'number', minimum: 0 },
        thousandSeparator: { type: 'boolean' },
        autoGenerated: { type: 'boolean' },
        inherited: { type: 'boolean' }
    },
    required: ['format', 'autoGenerated', 'inherited']
};
let CustomFormat = CustomFormat_1 = class CustomFormat {
    constructor(format, decimalPlace, thousandSeparator, autoGenerated = false, inherited = false) {
        this.format = format;
        this.thousandSeparator = thousandSeparator;
        this.autoGenerated = autoGenerated;
        this.inherited = inherited;
        if (decimalPlace !== undefined && decimalPlace !== null) {
            this.decimalPlace = decimalPlace;
        }
        JSON.validate(this, CustomFormat_1);
    }
    copyWithAutoGeneratedTrue() {
        return new CustomFormat_1(this.format, this.decimalPlace, this.thousandSeparator, true, false);
    }
    copyWithInheritedTrue() {
        return new CustomFormat_1(this.format, this.decimalPlace, this.thousandSeparator, this.autoGenerated, true);
    }
    static defaultFormat(isNumber = true) {
        if (isNumber) {
            return new CustomFormat_1(DefaultSettings.format, DefaultSettings.decimalPlace, DefaultSettings.thousandSeparator, true, false);
        }
        return new CustomFormat_1(DefaultSettings.format, undefined, undefined, true, false);
    }
};
CustomFormat = CustomFormat_1 = __decorate([
    JsonSchema(schema)
], CustomFormat);
export { CustomFormat };
//# sourceMappingURL=customFormat.js.map